import { render, staticRenderFns } from "./userDetailsTrendChart.vue?vue&type=template&id=9dd22040&scoped=true"
import script from "./userDetailsTrendChart.vue?vue&type=script&lang=js"
export * from "./userDetailsTrendChart.vue?vue&type=script&lang=js"
import style0 from "./userDetailsTrendChart.vue?vue&type=style&index=0&id=9dd22040&lang=scss&scoped=true"
import style1 from "./userDetailsTrendChart.vue?vue&type=style&index=1&id=9dd22040&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd22040",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dd22040')) {
      api.createRecord('9dd22040', component.options)
    } else {
      api.reload('9dd22040', component.options)
    }
    module.hot.accept("./userDetailsTrendChart.vue?vue&type=template&id=9dd22040&scoped=true", function () {
      api.rerender('9dd22040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/historical/user-details-view/charts/userDetailsTrendChart.vue"
export default component.exports